import React from 'react';
import { Stack } from '@balance-web/stack';
import type { StackProps } from '@balance-web/stack';
export const FieldStack = (props: Omit<StackProps, 'gap'>) => {
  return <Stack {...props} gap="xxlarge" />;
};
